import { Skeleton } from '@/shared/components/ui/skeleton';

const GridConnectionCardSkeleton = () => {
  return (
    <div className="$tw-rounded-md $tw-border $tw-bg-foreground/5 $tw-px-10 $tw-py-4">
      <div className="$tw-grid $tw-grid-cols-1 $tw-items-center $tw-gap-4 md:$tw-grid-cols-3">
        {/* Info section: name + chargers/connectors */}
        <div className="$tw-flex $tw-flex-col $tw-items-center md:$tw-items-start">
          <Skeleton className="$tw-mb-2 $tw-h-8 $tw-w-48" />
          <Skeleton className="$tw-mb-1 $tw-h-4 $tw-w-32" />
          <Skeleton className="$tw-h-4 $tw-w-40" />
        </div>

        {/* Power chart section: pie chart + legend */}
        <div className="$tw-flex $tw-flex-col $tw-items-center $tw-justify-center md:$tw-justify-start xl:$tw-flex-row">
          <div className="$tw-flex $tw-flex-col $tw-items-center xl:$tw-mr-6">
            {/* Simulated pie chart */}
            <Skeleton className="$tw-size-28 $tw-rounded-full" />
            <div className="$tw-mt-2 $tw-flex $tw-w-full $tw-justify-between $tw-gap-4">
              <Skeleton className="$tw-h-3 $tw-w-10" />
              <Skeleton className="$tw-h-3 $tw-w-14" />
            </div>
          </div>
          {/* Power legend */}
          <div className="$tw-mt-4 $tw-flex $tw-flex-col $tw-gap-3 xl:$tw-mt-0">
            <div>
              <Skeleton className="$tw-mb-1 $tw-h-3 $tw-w-36" />
              <Skeleton className="$tw-h-5 $tw-w-36" />
            </div>
          </div>
        </div>

        {/* Connector status section: bar chart */}
        <div className="$tw-flex $tw-flex-col $tw-items-center $tw-justify-center">
          <Skeleton className="$tw-mb-3 $tw-h-4 $tw-w-40" />
          <div className="$tw-flex $tw-w-full $tw-justify-center $tw-gap-2">
            <div className="$tw-flex $tw-w-full $tw-flex-col $tw-gap-2">
              {Array.from({ length: 4 }).map((_, i) => (
                <div key={i} className="$tw-flex $tw-items-center $tw-gap-2">
                  <Skeleton className="$tw-h-3 $tw-w-20" />
                  <Skeleton className="$tw-h-2.5 $tw-flex-1" />
                </div>
              ))}
            </div>
            <div className="$tw-flex $tw-flex-col $tw-gap-2">
              {Array.from({ length: 4 }).map((_, i) => (
                <Skeleton key={i} className="$tw-h-3 $tw-w-10" />
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GridConnectionCardSkeleton;
